module.exports = __webpack_public_path__ + "img/compact.5ca71736.png";